module.exports = __webpack_public_path__ + "static/img/流程引擎_0.f13c42a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/流程引擎_0.jpg
// module id = yEpS
// module chunks = 1